import { render, staticRenderFns } from "./BaseColumn.vue?vue&type=template&id=5e479d4a&"
import script from "./BaseColumn.vue?vue&type=script&lang=js&"
export * from "./BaseColumn.vue?vue&type=script&lang=js&"
import style0 from "./BaseColumn.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports